import React from "react"
import { red500, grey200 } from "material-ui/styles/colors"
import CloseIcon from "material-ui/svg-icons/navigation/close"
import AppStateStore from "../../stores/AppStateStore"
interface IProps {
    content: string
    close(): void
}

const BannerAlert = (props: IProps) => {
    const width = `calc(100% - ${AppStateStore.getExpandNav() === "expanded" ? 264 : 120}px)`
    return props.content ?
        <div style={{ width, backgroundColor: red500, position: "fixed", top: 70, zIndex: 999, padding: 20, color: grey200, fontSize: 16 }}>
            {props.content}
            <CloseIcon
                style={{ float: "right", color: grey200 }}
                onClick={() => AppStateStore.setBannerAlertContent("")}
            />
        </div> :
        null
}

export default BannerAlert